<template>
  <div class="info-card-container">
    <!-- 主卡片容器 -->
    <el-card class="info-card" shadow="hover">
      <div>
        {{$t('studentProgramme.courseVersion')}}:{{detail.studying==0?'香港數學課程':'Hong Kong Mathematics Curriculum'}}
      </div>
      <div class="info-layout">

        <!-- 左侧图片区域 -->
        <div class="image-section">
          <img class="avatar cursor-pointer" src="@/assets/images/c1.png" style="height: 150px;width: 200px;"/>
        </div>

        <!-- 中间文字内容区域 -->
        <div class="content-section">
          <h2 class="main-title">香港數學課程</h2>
          <div class="description-content">
            <p v-for="(paragraph, index) in description" :key="index" class="description-paragraph">
<!--              {{ paragraph }}-->
            </p>
          </div>

          <!-- 额外信息标签 -->
          <div class="tags-container" v-if="tags && tags.length">
            <el-tag
                v-for="(tag, index) in tags"
                :key="index"
                :type="tag.type || 'info'"
                class="info-tag"
            >
<!--              {{ tag.text }}-->
            </el-tag>
          </div>
        </div>

        <!-- 右侧按钮区域 -->
        <div class="actions-section">
          <el-button type="warning" round style="color: white" @click="updateStudying(0)">{{ $t("studentProgramme.switching") }}</el-button>
        </div>
        <!-- 左侧图片区域 -->
        <div class="image-section">
          <img class="avatar cursor-pointer" src="@/assets/images/c2.png" style="height: 150px;width: 200px;"/>
        </div>

        <!-- 中间文字内容区域 -->
        <div class="content-section">
          <h2 class="main-title">Hong Kong Mathematics Curriculum</h2>
          <div class="description-content">
            <p v-for="(paragraph, index) in description" :key="index" class="description-paragraph">
<!--              {{ paragraph }}-->
            </p>
          </div>

          <!-- 额外信息标签 -->
          <div class="tags-container" v-if="tags && tags.length">
            <el-tag
                v-for="(tag, index) in tags"
                :key="index"
                :type="tag.type || 'info'"
                class="info-tag"
            >
<!--              {{ tag.text }}-->
            </el-tag>
          </div>
        </div>

        <!-- 右侧按钮区域 -->
        <div class="actions-section">
          <el-button type="warning" round style="color: white" @click="updateStudying(1)">{{ $t("studentProgramme.switching") }}</el-button>
        </div>
      </div>
    </el-card>
  </div>
</template>

<script>

import {getProfile, updateStudying} from "@/api/user";
import {getUserInfo, removeAll, removeToken, setUserInfo} from "@/utils/auth";
import {logout} from "@/api/security";

export default {
  name: 'InfoCard',
  props: {
    detail: {
      type: Object,
      default: function () {},
    },
  },
  data() {
    return {
      // 标题
      title: '高级数据分析平台',

      // 描述内容（数组形式，支持多段落）
      description: [
        '本平台提供全方位的数据分析解决方案，帮助企业快速挖掘数据价值，提升决策效率。',
        '集成了机器学习算法与可视化工具，支持实时数据处理与多维度分析，适用于各类行业场景。'
      ],

      // 标签信息
      tags: [
        { text: '数据分析', type: 'primary' },
        { text: '实时处理', type: 'success' },
        { text: '可视化', type: 'info' }
      ]
    };
  },
  mounted() {
    this.getProfile();
  },
  methods: {
    getProfile() {
      getProfile().then((v) => {
        let detail = JSON.parse(JSON.stringify(v.data));
        this.$emit("update:detail", detail);
        setUserInfo("userProfile", detail);
      });
    },
    updateStudying(studying) {
      let d = JSON.parse(JSON.stringify(this.detail));
      d.studying = studying;

      this.$confirm(
          this.$t('common.confirmSwitchAndLogout'),
          this.$t('common.tip'),
          {
            confirmButtonText: this.$t('common.confirm'),
            cancelButtonText: this.$t('common.cancel'),
            type: 'warning'
          }
      ).then(async () => {
        await updateStudying(d);
        d.subscriptionIndex = 0
        this.$emit("update:detail", d);
        setUserInfo("userProfile", d);
        this.$set(d, "gradeId", d.grade?.id || d.subscriptions[d.subscriptionIndex].gradeId);
        if(d.studying==0){
          this.$i18n.locale = "zh_tc";
          this.$store.dispatch("setLanguage", "zh_tc");
        }else{
          this.$i18n.locale = "en";
          this.$store.dispatch("setLanguage", "en");
        }
        this.$message.success(this.$t('studentProgramme.coursesWitchingSuccessful'));
        setTimeout(() => {
          this.logout1();
        }, 1500);
      }).catch(() => {
        // 用户点击取消，不做任何操作
      });
    },
    /** 登出逻辑 */
    logout1() {
      const form = { refreshToken: getUserInfo("refreshToken") };
      logout(form)
          .then(() => this.clearLoginData())
          .catch(() => this.clearLoginData());
    },

    /** 抽离登出清除缓存公共逻辑 */
    clearLoginData() {
      removeToken();
      removeAll();
      window.sessionStorage.clear();
      this.leaveSwitch = false;
      this.$router.push({ path: "/login" });
    },
  }
};
</script>

<style scoped>
.info-card-container {
  padding: 9.375rem 4vw 4vw;
  max-width: 1200px;
  margin: 0 auto;
}

.info-card {
  border-radius: 12px;
  overflow: hidden;
}

.info-layout {
  display: flex;
  flex-wrap: wrap;
  width: 100%;
}

/* 左侧图片区域 */
.image-section {
  flex: 0 0 30%;
  min-width: 250px;
  padding: 15px;
  box-sizing: border-box;
}

.info-image {
  width: 100%;
  height: 100%;
  min-height: 150px;
  border-radius: 8px;
  transition: transform 0.3s ease;
}

.info-image:hover {
  transform: scale(1.02);
}

.image-placeholder {
  width: 100%;
  height: 150px;
  background-color: #f5f7fa;
  display: flex;
  align-items: center;
  justify-content: center;
  color: #c0c4cc;
}

/* 中间内容区域 */
.content-section {
  flex: 0 0 45%;
  min-width: 300px;
  padding: 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.main-title {
  margin: 0 0 20px 0;
  color: #1f2329;
  font-size: 24px;
  font-weight: 600;
  line-height: 1.3;
}

.description-content {
  margin-bottom: 25px;
}

.description-paragraph {
  margin: 0 0 12px 0;
  color: #4e5969;
  line-height: 1.7;
  font-size: 15px;
}

.tags-container {
  display: flex;
  gap: 10px;
  flex-wrap: wrap;
}

.info-tag {
  cursor: pointer;
  transition: all 0.2s ease;
}

.info-tag:hover {
  transform: translateY(-2px);
}

/* 右侧按钮区域 */
.actions-section {
  flex: 0 0 25%;
  min-width: 200px;
  padding: 25px;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 15px;
}

.action-button {
  width: 100%;
  transition: all 0.2s ease;
}

.action-button:hover {
  transform: translateY(-2px);
}

/* 响应式调整 */
@media (max-width: 992px) {
  .info-layout {
    flex-direction: column;
  }

  .image-section,
  .content-section,
  .actions-section {
    flex: none;
    width: 100%;
  }

  .actions-section {
    align-items: stretch;
  }

  .main-title {
    font-size: 22px;
    text-align: center;
  }
}

@media (max-width: 576px) {
  .info-card-container {
    padding: 10px;
  }

  .content-section,
  .actions-section {
    padding: 15px;
  }

  .main-title {
    font-size: 20px;
  }

  .description-paragraph {
    font-size: 14px;
  }
}
</style>
